import { useSelector } from 'react-redux';
import { DialogActions, Button } from '@mui/material';

import { DeleteButton } from './DeleteButton';
import { AddButton } from './AddButton';
import { UpdateButton } from './UpdateButton';
import { selectEventDialogDataId } from 'main/store/schedule/selectors';

type Props = {
    onClose: () => void;
}

export const Actions = ({ onClose }: Props) => {
    const id = useSelector(selectEventDialogDataId);

    return (
        <DialogActions>
            {!id && <AddButton />}
            {id && <UpdateButton />}
            {id && <DeleteButton />}
            <Button onClick={onClose}>キャンセル</Button>
        </DialogActions>
    )
}
